import { useState, useEffect } from 'react';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AddNewItem from '../AddNewItem/AddNewItem';
import ItemWithDeleteOption from '../ItemWithDeleteOption/ItemWithDeleteOption';
import { ValuesType } from 'state/forms/forms.reducer';
import {
  Control,
  Controller,
  FieldErrorsImpl,
  UseFormRegister,
  UseFormSetValue,
  UseFormGetValues,
} from 'react-hook-form';
import ErrorBadge from './../ErrorBadge/ErrorBadge';
import { useAppSelector } from 'hooks/useRedux';
import { useAppDispatch } from 'state/store';
import { formsActions } from 'state/forms';
import { isASCII } from 'constants/validationRules';
import { NON_ASCII_CHARACTER } from 'constants/validationMessages';
export interface InteractiveItemListProps {
  label: string;
  getValues?: UseFormGetValues<ValuesType>;
  setValue?: UseFormSetValue<ValuesType>;
  register: UseFormRegister<ValuesType>;
  required?: boolean;
  control?: Control<ValuesType>;
  formKey: string;
  isDisabled?: boolean;
  errors?: Partial<
    FieldErrorsImpl<{
      [x: string]: NonNullable<string | string[]>;
    }>
  >;
}

const InteractiveItemList = ({
  label,
  formKey,
  setValue,
  getValues,
  errors,
  required,
  control,
  isDisabled,
}: InteractiveItemListProps) => {
  const initialState = getValues && (getValues(formKey) as string[]);

  const [items, setItems] = useState<string[]>(initialState || []);
  const [newItemValue, setNewItemValue] = useState<string>('');
  const [errorsInput, setErrorsInput] = useState<string[]>([]);

  useEffect(() => {
    if (setValue) {
      setValue(formKey, items, {
        shouldDirty: true,
        shouldValidate: true,
      });
    }
  }, [items.length]);

  const handleOnSave = () => {
    const checkNewValue = newItemValue.replace(/ /g, '');

    if (items.find((m) => m.replace(/ /g, '') === checkNewValue)) {
      setErrorsInput(['This item has already been added']);
      return;
    }

    if (checkNewValue === '') {
      setErrorsInput([]);
      setNewItemValue('');
      return;
    }

    setItems([...items, newItemValue]);
    setNewItemValue('');
    setErrorsInput([]);
  };

  const validationBudge = errors && errors[formKey] && (
    <ErrorBadge
      errors={errors}
      formKey={formKey}
    />
  );

  return (
    <div className="mt-3">
      <Controller
        name={formKey}
        control={control}
        render={() => (
          <>
            <AddNewItem
              errors={items.length ? [...errorsInput] : []}
              setValue={(value) => {
                setNewItemValue(value);
              }}
              placeholder={`Enter ${label}`}
              value={newItemValue}
              onSave={handleOnSave}
              isDisabled={isDisabled}
            />
          </>
        )}
        rules={{
          required: {
            value: required ? true : false,
            message: `${label} field is required`,
          },
          validate: {
            ascii: (value) => {
              if (!Array.isArray(value)) return true;

              const isAscii = value.every((item) => {
                return isASCII(item) === true;
              });

              return isAscii || NON_ASCII_CHARACTER;
            },
          },
        }}
      />
      {validationBudge}
      <div className="py-2">
        {items.map((item, index) => (
          <ItemWithDeleteOption
            key={index}
            onClick={() => {
              const newItems = items.filter((i) => i !== item);
              setItems(newItems);
            }}
            name={item}
          />
        ))}
      </div>
    </div>
  );
};

export default InteractiveItemList;
